import React from 'react'
import { Modal } from '@surecompanies/core_components'
import { Button } from '@sureco/design-system'
import { CensusFileRowCountsDto } from '../../api/dto/census-file-row-counts.dto'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'

interface WithdrawAllConfirmationModalProps {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
  loading: boolean
  recordCount: number
  counts?: CensusFileRowCountsDto
}

const TAB_BREAKDOWN: { key: CensusFileRowTypeEnum; label: string }[] = [
  { key: CensusFileRowTypeEnum.ERROR, label: 'Errors' },
  { key: CensusFileRowTypeEnum.DRAFT_EMPLOYEE, label: 'New Records' },
  {
    key: CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS,
    label: 'Updates With Benefits',
  },
  {
    key: CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS,
    label: 'Updates Without Benefits',
  },
  { key: CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE, label: 'Duplicates' },
]

const WithdrawAllConfirmationModal = ({
  visible,
  onCancel,
  onConfirm,
  loading,
  recordCount,
  counts,
}: WithdrawAllConfirmationModalProps) => {
  const totalAllTabs = counts
    ? TAB_BREAKDOWN.reduce((sum, { key }) => sum + (counts[key] ?? 0), 0)
    : recordCount

  return (
    <Modal
      title="Confirm Withdraw All"
      open={visible}
      onCancel={onCancel}
      width={480}
      footer={[
        <div
          key="footer"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            type="outline"
            variant="secondary"
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            loading={loading}
            variant="danger"
            size="large"
          >
            Withdraw All
          </Button>
        </div>,
      ]}
    >
      <p>
        You are about to withdraw <strong>{totalAllTabs}</strong>{' '}
        {totalAllTabs === 1 ? 'record' : 'records'} across all tabs. This action
        cannot be easily undone.
      </p>
      {counts && (
        <ul style={{ paddingLeft: '20px', marginBottom: '12px' }}>
          {TAB_BREAKDOWN.map(({ key, label }) => {
            const count = counts[key] ?? 0
            if (count === 0) return null
            return (
              <li key={key}>
                {label}: <strong>{count}</strong>
              </li>
            )
          })}
        </ul>
      )}
      <p>Are you sure you want to continue?</p>
    </Modal>
  )
}

export default WithdrawAllConfirmationModal
